import {
  audioAnalysisSnapshotSchema,
  type AudioAnalysisSnapshot,
  type CoviChatItem,
} from "../model/types"

export type { AudioAnalysisItem, AudioAnalysisSnapshot } from "../model/types"

export function parseAudioAnalysis(
  value: unknown,
): AudioAnalysisSnapshot | null {
  const parsed = audioAnalysisSnapshotSchema.safeParse(value)
  return parsed.success ? parsed.data : null
}

export function parseAudioAnalyses(value: unknown): AudioAnalysisSnapshot[] {
  if (!Array.isArray(value) || value.length > 8) {
    return []
  }
  return value.flatMap((item) => {
    const parsed = parseAudioAnalysis(item)
    return parsed ? [parsed] : []
  })
}

export function upsertAudioAnalyses(
  items: CoviChatItem[],
  snapshots: AudioAnalysisSnapshot[],
): CoviChatItem[] {
  const updated = [...items]
  for (const analysis of snapshots) {
    const index = updated.findIndex(
      (item) =>
        item.kind === "analysis" &&
        item.analysis.analysis_id === analysis.analysis_id,
    )
    if (index < 0) {
      updated.push({
        kind: "analysis",
        id: `analysis-${analysis.analysis_id}`,
        analysis,
        firstSeenAt: Date.now(),
      })
    } else {
      const previous = updated[index]
      if (
        previous?.kind === "analysis" &&
        previous.analysis.status === "running" &&
        analysis.status === "queued"
      ) {
        continue
      }
      if (
        previous?.kind === "analysis" &&
        previous.analysis.status !== "succeeded" &&
        previous.analysis.status !== "failed"
      ) {
        updated[index] = { ...previous, analysis }
      }
    }
  }
  return updated
}
